import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { DialogNgbService, PipesModule } from '@motivforce/mx-library-angular';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { BankDetailsDialogComponent } from './components/bank-details-dialog/bank-details-dialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { ProductCataloguePopUpDialogComponent } from './components/product-catalougue-pop-up-dialog/product-catalougue-pop-up-dialog.component';
import { TermsConditionsAcceptDialogComponent } from './components/terms-conditions-accept-dialog/terms-conditions-accept-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [
    DialogComponent,
    TermsConditionsAcceptDialogComponent,
    ConfirmationDialogComponent,
    BankDetailsDialogComponent,
    ProductCataloguePopUpDialogComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [NgbModalModule],
})
export class DialogModule {
  constructor(private dialog: DialogNgbService, private iconlibrary: FaIconLibrary) {
    this.dialog.registerNotificationDialog(DialogComponent);
    this.dialog.registerErrorDialog(DialogComponent);
    this.dialog.registerWarningDialog(DialogComponent);
    this.dialog.registerValidationDialog(DialogComponent);
    this.dialog.registerConfirmationDialog(ConfirmationDialogComponent);

    this.dialog.registerFeatureDialog('termsConditionsAcceptDialog', TermsConditionsAcceptDialogComponent);
    this.dialog.registerFeatureDialog('bankDetailsDialog', BankDetailsDialogComponent);
    this.dialog.registerFeatureDialog('productCataloguePopUp', ProductCataloguePopUpDialogComponent);

    this.iconlibrary.addIcons(faClock, faChevronRight);
  }
}
